import { RootState } from "@/store";
import { useSelector } from "react-redux";

export const useExceptionItems = () =>
  useSelector((state: RootState) => state.exceptionItem.items);
